import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=cd72e4e0&lang=css"

const __exports__ = script;

export default __exports__